var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector87(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 319,
    viewBox: "0 0 340 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.533 318.408C315.295 298.806 311.454 294.537 296.101 274.424C292.338 269.497 286.419 259.917 280.766 248.086C279.072 244.545 277.536 241.034 276.128 237.572C266.082 212.797 264.664 185.042 266.998 157.631C272.957 87.6922 235.099 24.5695 177.78 6.16772C120.363 -12.2635 56.604 18.0585 25.4925 65.376C21.4448 71.5328 3.58938 100.586 0.949973 132.462C-7.41143 233.106 90.0792 273.323 238.418 303.773C241.303 304.363 255.042 306.615 257.957 307.018L339.542 318.417L339.533 318.408Z",
    fill: "#1E1E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector87);
export default __webpack_public_path__ + "static/media/vector8-7.22800bfd3a6b20978a56f57c907e7306.svg";
export { ForwardRef as ReactComponent };